import ArrowUp from "./SVG/arrowUp.svg?react";

const ArrowUpIcon = () => {
  return <ArrowUp />;
};

export default ArrowUpIcon;
